 import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";
import Swal from "sweetalert2";

export const getGastosByFecha = async ({ fechainicio, fechafin }) => {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/gastos/bydate`, {
      method: "POST", // <-- POST (coincide con el backend)
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ fechainicio, fechafin }), // <-- body (coincide con req.body)
    });

    if (!response.ok) {
      // intenta extraer mensaje del backend
      let msg = "Error al obtener los gastos";
      try {
        const errJson = await response.json();
        if (errJson?.message) msg = errJson.message;
      } catch (_) {}
      throw new Error(msg);
    }

    const json = await response.json(); // { message, gastos }
    return Array.isArray(json?.gastos) ? json.gastos : [];
  } catch (error) {
    Swal.fire({ icon: "error", title: "Error", text: error.message });
    return [];
  }
};
export const getPagosProfesionalesByFecha = async ({ fechainicio, fechafin }) => {
  const token = getAuthToken();
  try {
    const response = await fetch(`${CALL_API}/pagoprofesionales/bydate`, {
      method: "POST", // <-- POST como el backend
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ fechainicio, fechafin }), // <-- req.body
    });

    if (!response.ok) {
      let msg = "Error al obtener los pagos profesionales";
      try {
        const errJson = await response.json();
        if (errJson?.message) msg = errJson.message;
      } catch {}
      throw new Error(msg);
    }
    const json = await response.json(); // { message, profesionales }
    return Array.isArray(json?.profesionales) ? json.profesionales : [];
  } catch (error) {
    Swal.fire({ icon: "error", title: "Error", text: error.message });
    return [];
  }
};
/**
 * Obtener pagos a proveedores por rango de fechas (YYYY-MM-DD)
 * @param {{ fechainicio: string, fechafin: string }} params
 * @returns {Promise<Array>}
 */
export const getPagoProveedoresByFecha = async ({ fechainicio, fechafin }) => {
  if (!fechainicio || !fechafin) {
    throw new Error("fechainicio y fechafin son requeridos (YYYY-MM-DD).");
  }

  const token = getAuthToken();

  const response = await fetch(`${CALL_API}/getallpagoproveedoresbydate`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      startDate: fechainicio,
      endDate: fechafin,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    // el backend devuelve { message, ... }
    throw new Error(data.message || "Error al obtener pagos de proveedores por fecha");
  }

  // backend: res.status(200).json({ message: "OK", result: result[0][0] })
  return Array.isArray(data.result) ? data.result : [];
};